import apiService from './apiService';

export const getOutageRequisition = async (page = 1, search = '') => {
  try {
    const params = new URLSearchParams({
      page: String(page),
    });

    if (search) {
      params.append('filter[search]', search);
    }

    const response = await apiService.get(`outage-requisitions?${params.toString()}`);

    return response.data;
  } catch (error) {
    console.error('Error fetching outage-requisitions:', error);
    throw error;
  }
};

export const getOutageRequisitionDetail = async (id: number | string) => {
  try {
    const response = await apiService.get(`outage-requisitions/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching outage-requisitions:', error);
    throw error;
  }
};

export const createOutageRequisition = async (payload: any) => {
  try {
    const response = await apiService.post(`outage-requisitions`, payload);
    return response.data;
  } catch (error) {
    console.error('Error creating outage-requisition:', error);
    throw error;
  }
};

export const updateOutageRequisition = async (id: number | string, payload: any) => {
  try {
    const response = await apiService.put(`outage-requisitions/${id}`, payload);
    return response.data;
  } catch (error) {
    console.error('Error updating outage-requisition:', error);
    throw error;
  }
};

export const deleteOutageRequisition = async (id: number | string) => {
  try {
    const response = await apiService.delete(`outage-requisitions/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting outage-requisition:', error);
    throw error;
  }
};

export const getUnitsDropdown = async () => {
  try {
    const response = await apiService.get(`outage-requisitions/dropdowns/units`);
    return response.data;
  } catch (error) {
    console.error('Error fetching units dropdown:', error);
    throw error;
  }
};

export const getOutageTypesDropdown = async () => {
  try {
    const response = await apiService.get(`outage-requisitions/dropdowns/outagetypes`);
    return response.data;
  } catch (error) {
    console.error('Error fetching outage types dropdown:', error);
    throw error;
  }
};

export const notifySrConfirm = async (id: string | number, payload: { user_ids: number[] }) => {
  try {
    const response = await apiService.post(`/outage-requisitions/${id}/notify-sr-confirm`, {
      ...payload,
    });

    return response.data;
  } catch (error) {
    console.error('Error notifying senior planner:', error);
    throw error;
  }
};

export const getSeniorPlanners = async () => {
  try {
    const response = await apiService.get('/users?filter[user_type_id]=18');

    return response.data;
  } catch (error) {
    console.error('Error fetching senior planners:', error);
    throw error;
  }
};

export const markSrConfirmed = async (id: number | string) => {
  try {
    const response = await apiService.post(`/outage-requisitions/${id}/mark-sr-confirmed`, {});
    return response.data;
  } catch (error) {
    console.error('Error marking SR confirmed:', error);
    throw error;
  }
};

export const getTechnicalSupportOfficers = async () => {
  try {
    const response = await apiService.get('/users?filter[user_type_id]=11');

    return response.data;
  } catch (error) {
    console.error('Error fetching Technical Support Officers:', error);
    throw error;
  }
};

export const notifyTSOConfirm = async (id: string | number, payload: { user_ids: number[] }) => {
  try {
    const response = await apiService.post(`/outage-requisitions/${id}/notify-tso-confirm`, {
      ...payload,
    });

    return response.data;
  } catch (error) {
    console.error('Error notifying TSO:', error);
    throw error;
  }
};

export const markTSOConfirmed = async (id: number | string) => {
  try {
    const response = await apiService.post(`/outage-requisitions/${id}/mark-tso-confirmed`, {});

    return response.data;
  } catch (error) {
    console.error('Error marking TSO confirmed:', error);
    throw error;
  }
};

export const getMaintenanceManagers = async () => {
  try {
    const response = await apiService.get('/users?filter[user_type_id]=13');

    return response.data;
  } catch (error) {
    console.error('Error fetching Maintenance Managers:', error);
    throw error;
  }
};

export const notifyMMApprove = async (id: string | number, payload: { user_ids: number[] }) => {
  try {
    const response = await apiService.post(`/outage-requisitions/${id}/notify-mm-approve`, {
      ...payload,
    });

    return response.data;
  } catch (error) {
    console.error('Error notifying Maintenance Manager:', error);
    throw error;
  }
};

export const markMMApproved = async (id: number | string, remarks?: string) => {
  try {
    const response = await apiService.post(`/outage-requisitions/${id}/mark-mm-approved`, {
      ...(remarks?.trim() ? { remarks: remarks.trim() } : {}),
    });

    return response.data;
  } catch (error) {
    console.error('Error marking MM approved:', error);
    throw error;
  }
};

export const getTechnicalManagers = async () => {
  try {
    const response = await apiService.get('/users?filter[user_type_id]=8');

    return response.data;
  } catch (error) {
    console.error('Error fetching Technical Managers:', error);
    throw error;
  }
};

export const notifyTMApprove = async (id: string | number, payload: { user_ids: number[] }) => {
  try {
    const response = await apiService.post(`/outage-requisitions/${id}/notify-tm-approve`, {
      ...payload,
    });

    return response.data;
  } catch (error) {
    console.error('Error notifying Technical Manager:', error);
    throw error;
  }
};

export const markTMApproved = async (id: number | string, remarks?: string) => {
  try {
    const response = await apiService.post(`/outage-requisitions/${id}/mark-tm-approved`, {
      ...(remarks?.trim() ? { remarks: remarks.trim() } : {}),
    });

    return response.data;
  } catch (error) {
    console.error('Error marking TM approved:', error);
    throw error;
  }
};

export const getOperationManagers = async () => {
  try {
    const response = await apiService.get('/users?filter[user_type_id]=9');

    return response.data;
  } catch (error) {
    console.error('Error fetching Operation Managers:', error);
    throw error;
  }
};

export const notifyOMApprove = async (id: string | number, payload: { user_ids: number[] }) => {
  try {
    const response = await apiService.post(`/outage-requisitions/${id}/notify-om-approve`, {
      ...payload,
    });

    return response.data;
  } catch (error) {
    console.error('Error notifying Operation Manager:', error);
    throw error;
  }
};

export const markOMApproved = async (id: number | string, remarks?: string) => {
  try {
    const response = await apiService.post(`/outage-requisitions/${id}/mark-om-approved`, {
      ...(remarks?.trim() ? { remarks: remarks.trim() } : {}),
    });

    return response.data;
  } catch (error) {
    console.error('Error marking OM approved:', error);
    throw error;
  }
};

export const getShiftSupervisors = async () => {
  try {
    const response = await apiService.get('/users?filter[user_type_id]=2');

    return response.data;
  } catch (error) {
    console.error('Error fetching Shift Supervisors:', error);
    throw error;
  }
};

export const notifyShutdown = async (id: string | number, payload: { user_ids: number[] }) => {
  try {
    const response = await apiService.post(`/outage-requisitions/${id}/notify-shutdown`, {
      ...payload,
    });

    return response.data;
  } catch (error) {
    console.error('Error notifying Shift Supervisor:', error);
    throw error;
  }
};

export const markShutdown = async (id: number | string) => {
  try {
    const response = await apiService.post(`/outage-requisitions/${id}/mark-shutdown`, {});

    return response.data;
  } catch (error) {
    console.error('Error marking shutdown:', error);
    throw error;
  }
};

export const downloadOutageRequisitionPdf = async (id: number | string) => {
  try {
    const response = await apiService.get(`/outage-requisitions/${id}/download`, {
      responseType: 'blob',
    });

    return response.data;
  } catch (error) {
    console.error('Error downloading outage requisition PDF:', error);
    throw error;
  }
};
